/**
 * Represents a clock-out request for a time entry.
 */
export class TimeEntryClockOutRequest {
  /**
   * @param {Object} requestData - The request data object.
   * @param {number} requestData.bookingId - The ID of the booking to clock out for.
   */
  constructor(requestData) {
    /**
     * The ID of the booking to clock out for.
     * @type {number}
     */
    this.bookingId = requestData.bookingId
  }
}
